"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function DevLogsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const rotations = ["-rotate-2", "rotate-1", "-rotate-1"];
  const tapeRotations = ["-rotate-12", "rotate-6"];
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="bg-white border border-gray-200 rounded-lg p-3.5 pb-14 animate-pulse shadow-md">
            <div className="aspect-[4/3] bg-gray-100 mb-4 rounded-md" />
            <div className="h-3 bg-gray-100 w-1/3 mb-3" />
            <div className="h-5 bg-gray-100 w-4/5 mb-2" />
            <div className="h-5 bg-gray-100 w-3/5" />
          </div>)}
      </div>;
  }
  if (error || posts.length === 0) {
    return <p className="font-default text-sm uppercase tracking-widest text-blue-700">
        No security insights available at this time.
      </p>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 lg:gap-12">
      {displayPosts.map((post, i) => {
      const date = post.date ? new Date(post.date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit"
      }) : "";
      return <article data-index={i} key={post.id} className="group relative bg-white border border-gray-200 rounded-lg p-3.5 pb-14 transition-all duration-300 ease-out shadow-md hover:shadow-xl">
            <div className={`absolute -top-3 left-4 w-16 h-6 bg-blue-600/20 ${tapeRotations[0]} z-10`} aria-hidden="true" />
            <div className={`absolute -top-3 right-4 w-16 h-6 bg-blue-600/20 ${tapeRotations[1]} z-10`} aria-hidden="true" />

            <div className="relative aspect-[4/3] border border-gray-100 overflow-hidden bg-gray-50 rounded-md">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" /> : <div className="w-full h-full bg-blue-50 flex items-center justify-center">
                  <span className="font-default text-4xl text-blue-600">
                    
                  </span>
                </div>}
            </div>

            <p className="mt-4 font-default text-[11px] uppercase tracking-[0.18em] text-blue-600/70">
              {date}
            </p>

            <h3 className="mt-2 font-default text-lg md:text-xl font-bold leading-tight text-gray-900 line-clamp-2">
              {post.title}
            </h3>

            <Link to={post.link || "#"} className="absolute bottom-4 left-4 right-4 inline-flex items-center justify-center">
              <span className="inline-flex items-center gap-1.5 bg-blue-600 text-white rounded-lg px-4 py-1.5 font-default text-[11px] uppercase tracking-[0.15em] font-semibold hover:bg-blue-700 transition-colors">
                Read Analysis
                <ArrowRight className="size-3" />
              </span>
            </Link>
          </article>;
    })}
    </div>;
}
export default function Blog() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  const tickerItems = ["ENCRYPTION UPDATES", "GLOBAL SERVER EXPANSION", "PRIVACY PROTOCOLS", "SECURITY AUDIT LIVE", "THREAT INTELLIGENCE", "VPNGENIX SECURE"];
  return <section data-section-id="1190" id="blog" className="relative bg-white text-gray-900 py-28 md:py-40 overflow-hidden">
      <div className="container mx-auto max-w-[1440px] px-4 md:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-20">
          <div className="md:col-span-8">
            <p className="font-default text-xs md:text-sm uppercase tracking-[0.18em] text-blue-600 mb-6 font-semibold">
              VPNGENIX / SECURITY INSIGHTS
            </p>
            <h2 className="font-default text-gray-900 leading-[1.1] font-bold" style={{
            fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
            letterSpacing: "-0.025em"
          }}>
              Latest{" "}
              <span className="text-blue-600">
                Security Intelligence
              </span>
              .
            </h2>
          </div>

          <div className="md:col-span-4 flex md:justify-end md:items-end">
            <Link to="#" className="group inline-flex items-center">
              <Button variant="ghost" className="bg-transparent border-2 border-blue-600 text-blue-600 rounded-lg px-5 py-2.5 font-default text-xs uppercase tracking-[0.18em] font-semibold hover:bg-blue-600 hover:text-white transition-all">
                View All Articles
              </Button>
            </Link>
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date",
        status: ["publish"]
      }}>
          <DevLogsConsumer />
        </PostsProvider>
      </div>

      <div className="relative mt-20 md:mt-28 border-t border-gray-200 overflow-hidden bg-gray-50">
        <div className="flex whitespace-nowrap py-4 animate-[ticker_60s_linear_infinite]">
          {[...Array(3)].map((_, repeatIdx) => <div key={repeatIdx} data-index={repeatIdx} className="flex shrink-0">
              {tickerItems.map((item, i) => <span key={`${repeatIdx}-${i}`} className="font-default text-sm md:text-base uppercase tracking-[0.2em] text-gray-500 font-medium px-6 inline-flex items-center">
                  <span className="mr-6 text-blue-600">◆</span>
                  {item}
                </span>)}
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}